import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './lib/auth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Equipments from './pages/Equipments'
import Search from './pages/Search'
import Exports from './pages/Exports'
import AuditLog from './pages/AuditLog'
import Storage from './pages/Storage'
import AdminInstalls from './pages/AdminInstalls'
import Activation from './pages/Activation'
import './styles.css'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-400">
        Carregando…
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  return <>{children}</>
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/activation" element={<Activation />} />
          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/equipments" element={<Equipments />} />
            <Route path="/search" element={<Search />} />
            <Route path="/exports" element={<Exports />} />
            <Route path="/storage" element={<Storage />} />
            <Route path="/audit" element={<AuditLog />} />
            <Route path="/admin/installs" element={<AdminInstalls />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
